export default __webpack_public_path__ + "static/logo-33e0768ed8c19b11549837be93627355.svg";